import { Entity } from 'webpanel-admin';
import { api } from './api';

export const newsItemCategory = new Entity({
  name: 'NewsItemCategory',
  title: 'Kategorie aktualit',
  icon: 'tags',
  dataSource: api,
  searchable: true
}).inputField('name', {
  title: 'Název',
  sortable: true,
  filter: true
});



// WEBPACK FOOTER //
// ./src/model/newsitem-category.tsx